import React from 'react';
import ProfilePageContent from '../profile/ProfilePageContent';
import useMobileView from '../../hooks/useMobileView';
import { isMobileShellLayout } from '../../utils/mobileShellLayout';

const LandingProfile = () => {
  const { isCompact } = useMobileView();
  const useMobileDark = isCompact || isMobileShellLayout();

  return (
    <ProfilePageContent
      forceDarkHeader
      successMessageDefault="Password updated successfully!"
      navLinks={useMobileDark ? [] : [
        { url: '/onboarding/landing/', label: 'Dashboard' },
        { url: '/onboarding/landing/', label: 'Hotelier' },
        { url: '/onboarding/landing/', label: 'Users' },
      ]}
      breadcrumbs={[
        { label: 'Home', path: '/onboarding/landing/' },
        { label: 'Profile' },
      ]}
    />
  );
};

export default LandingProfile;
